export default {
  common: {
    loading: 'Naglo-load',
    confirm: 'Kumpirmahin',
    cancel: 'Kanselahin',
    save: 'I-save',
    back: 'Bumalik',
    copy: 'Kopyahin',
    delete: 'Tanggalin',
    copySuccess: 'Matagumpay na nakopya',
    editSuccess: 'Matagumpay na na-edit',
    deleteSuccess: 'Matagumpay na natanggal',
    modifySuccess: 'Matagumpay na na-update',
    cannotBeEmpty: 'Hindi puwedeng walang laman',
    noContent: 'Walang nilalaman',
    noData: 'Walang kaugnay na data',
    noMoreData: 'Wala nang karagdagang data',
    iKnow: 'Naiintindihan ko',
    selectService: 'Pumili ng provider',
    sendSuccess: 'Naipadala',
  },
  billHome: {
    recharge: 'Pag-recharge at Bayad',
    coupon: 'Kupon',
    rechargeNow: 'Mag-recharge Ngayon',
    cost: 'Load / Tawag',
    flow: 'Data',
    rechargeNotice: 'Impormasyon bago mag-recharge',
    rechargeCost: 'Recharge ng Load',
    rechargeFlow: 'Recharge ng Data',
    rechargeAmount: 'Halaga ng Recharge',
    rechargePackage: 'Recharge Package',
    discount: 'May diskwento',
    confirmTxt: 'Kumpirmadong tama',
    confirmTxt1: 'Naiintindihan ko',
    actualPayment: 'Kabuuang Bayad',
    selectCoupon: 'Pumili ng Kupon',
    useRule: 'Mga Alituntunin sa Paggamit',
    availableCoupon: 'Mga Kupon na Magagamit',
    unavailableCoupon: 'Hindi magagamit na mga kupon',
    noAvailableCoupon: 'Walang magagamit na kupon',
    selectPhone: 'Pumili ng numero ng telepono',
    pleaseInputPhone: 'Ilagay ang Numero',
    couponCount: 'Magagamit na Kupon',
    pleaseInputCorrectPhone: 'Mangyaring maglagay ng tamang numero ng telepono',
    pleaseSelectPackage: 'Mangyaring pumili ng package na may halaga',
  },
  accountManage: {
    title: 'Pamamahala ng Account',
    edit: 'I-edit',
    deleteConfirm: 'Kumpirmahin ang pagtanggal',
  },
  rechargeDetail: {
    title: 'Detalye ng Bayad',
    continuePay: 'Magpatuloy sa Pagbabayad',
  },
  feesExpense: {
    title: 'Kasaysayan ng Bayad',
    recharge: 'Load',
    electricity: 'Kuryente',
    internet: 'Internet',
    water: 'Tubig',
    photo: 'Larawan',
    complete: 'Tapos na',
    manage: 'Pamahalaan',
    allSelect: 'Piliin Lahat',
    selected: 'Napili na',
    deleteConfirm: '',
    deleteRecord: 'tanggalin ang bayad na ito?',
    noDataAction: 'Walang data na pwedeng i-manage',
    pleaseSelect: 'Pumili muna ng record na tatanggalin',
    feesNotice: 'Impormasyon bago magbayad',
  },
  formCom: {
    upload: 'I-click para mag-upload',
    saveAccount: 'I-save o i-update ang account',
    createOrder: 'Gumawa ng Order',
    rechargeIng: 'Nagre-recharge',
    rechargeNow: 'Mag-recharge Ngayon',
    serviceProvider: 'Service Provider',
    billImage: 'Larawan ng Bill',
    returnSelect: 'Bumalik para pumili muli',
    electricity: 'Bayad sa Kuryente',
    internet: 'Bayad sa Internet',
    water: 'Bayad sa Tubig',
    photo: 'Magbayad gamit ang larawan',
    life: 'Utility Bills',
    uploadFail: 'Nabigo ang upload, subukan muli',
    pleaseFill: 'Pakitapos ang impormasyon',
    submitSuccess: 'Naipasa na, hintayin ang bayad',
  },
  langPop: {
    selectLang: 'Pumili ng Wika',
  },
  loginPop: {
    loginOrRegister: 'Mag-login o Magrehistro gamit ang Kuaizi',
    confirmLogout: 'Sigurado ka bang gusto mong mag-logout?',
    toLogin: 'Mag-login',
    logoutSuccess: 'Matagumpay na na-logout',
  },
  newMe: {
    myOrder: 'Aking Mga Order',
    coupon: 'Kupon',
    accountManage: 'Pamamahala ng Account',
    orderCount: 'Order na isinasagawa',
    couponCount: 'Mga Kupon',
    account: 'Account',
    logout: 'Mag-logout',
  },
  coupons: {
    all: 'Lahat',
    coupon: 'Kupon',
    historyCoupon: 'History ng Kupon',
    use: 'Gamitin',
    validityPeriod: 'Petsa ng Bisa',
    useRule: 'Mga Alituntunin',
    used: 'Nagamit na',
    expired: 'Expired na',
  },
  accountSeting: {
    title: 'Mga Setting',
    personalInfo: 'Personal na Impormasyon',
    modifyPayPassword: 'Baguhin ang Password sa Pagbabayad',
    modifyLoginPassword: 'Baguhin ang Login Password',
    phone: 'Numero ng Telepono',
    code: 'Verification Code',
    loginPassword: 'Login Password',
    confirmModify: 'Kumpirmahin ang Pagbabago',
    noCode: 'Hindi nakatanggap ng code?',
    passwordPlaceholder: '8–16 character na kombinasyon ng letra at numero',
    inputCorrectPhone: 'Ilagay ang tamang numero',
    afterGetCode: 'maaari ulit makuha pagkatapos',
    getCode: 'Kunin ang Code',
    input6DigitPassword: 'Maglagay ng 6-digit na password',
    twoInputPasswordNotConsistent: 'Hindi tugma ang dalawang password',
    placeholderCode: 'Ilagay ang verification code',
    confirmPassword: 'Kumpirmahin ang Password',
    password: 'Password',
    submit: 'Isumite',
    avatar: 'Profile Picture',
    userName: 'Username',
    nickName: 'Palayaw',
    modifyPhone: 'Baguhin ang Numero ng Telepono',
    nickNamePlaceholder: 'Ilagay ang iyong identity',
    sex: 'Kasarian',
    male: 'Lalaki',
    female: 'Babae',
    email: 'Email',
    emailPlaceholder: 'Ilagay ang email para sa pag-reset ng password',
    pleaseCompletePersonalData: 'Pakilagay ang personal na impormasyon para sa karagdagang features',
    bindNewPhone: 'I-link ang bagong numero',
    oldPhone: 'Lumang Telepono',
    completeVerification: 'Tapusin ang Pag-verify',
    changePayPasswordTitle: 'Baguhin ang Payment Password',
    changePasswordTitle: 'Baguhin ang Password',
    oldPhoneTitle: 'I-verify ang Lumang Numero',
    editInfoTitle: 'I-edit ang Profile',
    areaCode: 'Area Code',
  },
}
